document.addEventListener('DOMContentLoaded', () => {

    const initializeSwipers = () => {
        const allSwipers = document.querySelectorAll('.swiper-snippet-container');

        allSwipers.forEach((swiperContainer) => {
            if (!swiperContainer.swiper) {
                const mobileSlidesPerView = swiperContainer.dataset?.slidesMobile || 2.5;
                const tabletSlidesPerView = swiperContainer.dataset?.slidesTablet || 3.5;
                const desktopSlidesPerView = swiperContainer.dataset?.slidesDesktop
                ? swiperContainer.dataset?.slidesDesktop 
                : swiperContainer.classList.contains('four-slides-per-view') ? 4 : 3;
                
                const spaceBetweenMobile = swiperContainer.dataset?.spaceBetweenMobile || 10;
                const spaceBetweenTablet = swiperContainer.dataset?.spaceBetweenTablet || 10;
                const spaceBetweenDesktop = swiperContainer.dataset?.spaceBetweenDesktop || 10;

                new Swiper(swiperContainer, {
                    slidesPerView: mobileSlidesPerView,
                    spaceBetween: spaceBetweenMobile,
                    loop: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    breakpoints: {
                        750: {
                            slidesPerView: tabletSlidesPerView,
                            spaceBetween: spaceBetweenTablet,
                        },
                        989: {
                            slidesPerView: desktopSlidesPerView,
                            spaceBetween: spaceBetweenDesktop,
                        },
                    },
                });
            }
        });
    };

    initializeSwipers();

    const observer = new MutationObserver(() => {
        initializeSwipers();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
});

